// AG Grid gives a column without an explicit width 200px; minWidth is only a floor
const DEFAULT_COLUMN_WIDTH = 200;

const getColumnSizing = (column) => {
  const width = Number(column.width);
  const minWidth = Number(column.minWidth);
  const hasWidth = Number.isFinite(width) && width > 0;
  const hasMinWidth = Number.isFinite(minWidth) && minWidth > 0;
  const hasConfiguredSize = (hasWidth || hasMinWidth) && !(column.flex > 0);

  return {
    ...(hasWidth && { width }),
    ...(!hasWidth && hasConfiguredSize && {
      width: Math.max(minWidth, DEFAULT_COLUMN_WIDTH),
    }),
    suppressAutoSize: hasConfiguredSize || column.suppressAutoSize,
    suppressSizeToFit: hasConfiguredSize || column.suppressSizeToFit,
  };
};

export default getColumnSizing;

const FIXED_UTILITY_FIELDS = ['checkboxSelection', 'dragColumn'];

const isFillCandidate = (column) =>
  !column.hide &&
  column.resizable !== false &&
  !column.children &&
  !FIXED_UTILITY_FIELDS.includes(column.field);

export const fillLastColumn = (columns) => {
  if (!columns?.length) return columns;
  if (columns.some((column) => column.children || column.flex > 0)) {
    return columns;
  }

  const fillIndex = columns.findLastIndex(isFillCandidate);
  if (fillIndex === -1) return columns;

  const { width, minWidth, ...column } = columns[fillIndex];
  const filled = {
    ...column,
    flex: 1,
    minWidth: Math.max(Number(width) || 0, Number(minWidth) || 0) || DEFAULT_COLUMN_WIDTH,
    suppressSizeToFit: false,
  };

  return columns.map((item, index) => (index === fillIndex ? filled : item));
};
